
export default function Intro() {
    return (
        <section className="w-100 items-center flex justify-center mt-16 mb-16 md:mb-16"
            style={{
                flexDirection: "column"
            }}
        >
            <h1 className="text-6xl md:text-7xl font-bold tracking-tighter leading-tight">
                Insights.
            </h1>
            <h2 className="text-center text-xl mt-3 text-gray-500 font-normal"

            >
                A hub of knowledge for commercial real estate and sale of business in Canada.
            </h2>
        </section>
    )
}
